<div class="angular-editor-toolbar" *ngIf="showToolbar">
    <div class="angular-editor-toolbar-set"
         [class.!hidden]="isButtonHidden('undo') || isButtonHidden('redo')">
        <button type="button"
                class="angular-editor-button"
                (click)="triggerCommand('undo')"
                [hidden]="isButtonHidden('undo')"
                [title]="appService.language_dictionary.text_editor_undo"
                tabindex="-1">
            <mat-icon>undo</mat-icon>
        </button>
        <button
            type="button" class="angular-editor-button" (click)="triggerCommand('redo')"
                [hidden]="isButtonHidden('redo')"
                [title]="appService.language_dictionary.text_editor_redo"
                tabindex="-1">
            <mat-icon>redo</mat-icon>
        </button>
    </div>
    <div class="angular-editor-toolbar-set">
        <button
            [id]="'bold-'+id" type="button"  class="angular-editor-button"
                (click)="triggerCommand('bold')"
                [title]="appService.language_dictionary.text_editor_bold"
                [disabled]="htmlMode"
                [hidden]="isButtonHidden('bold')" tabindex="-1">
            <mat-icon>format_bold</mat-icon>
        </button>
        <button
            [id]="'italic-'+id" type="button"  class="angular-editor-button"
                (click)="triggerCommand('italic')"
                [title]="appService.language_dictionary.text_editor_italic"
                [disabled]="htmlMode"
                [hidden]="isButtonHidden('italic')" tabindex="-1">
            <mat-icon>format_italic</mat-icon>
        </button>
        <button
            [id]="'underline-'+id" type="button"  class="angular-editor-button"
                (click)="triggerCommand('underline')"
                [title]="appService.language_dictionary.text_editor_underline"
                [disabled]="htmlMode"
                [hidden]="isButtonHidden('underline')"
                tabindex="-1">
            <mat-icon>format_underlined</mat-icon>
        </button>
        <button
            [id]="'strikeThrough-'+id" type="button"  class="angular-editor-button"
                (click)="triggerCommand('strikeThrough')" [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_strikethrough"
                [hidden]="isButtonHidden('strikeThrough')"
                tabindex="-1">
            <mat-icon>strikethrough_s</mat-icon>
        </button>
        <button
            [id]="'subscript-'+id" type="button"
                class="angular-editor-button"
                [title]="appService.language_dictionary.text_editor_subscript"
                (click)="triggerCommand('subscript')" [disabled]="htmlMode"
                [hidden]="isButtonHidden('subscript')"
                tabindex="-1">
            <mat-icon>subscript</mat-icon>
        </button>
        <button
            [id]="'superscript-'+id" type="button"  class="angular-editor-button"
                (click)="triggerCommand('superscript')"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_superscript"
                [hidden]="isButtonHidden('superscript')"
                tabindex="-1">
            <mat-icon>superscript</mat-icon>
        </button>
    </div>
    <div class="angular-editor-toolbar-set"
         [class.!hidden]="isButtonHidden('justifyLeft') || isButtonHidden('justifyCenter')
            || isButtonHidden('justifyRight') || isButtonHidden('justifyFull')">
        <button *ngIf="!isButtonHidden('justifyLeft')"
            [id]="'justifyLeft-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('justifyLeft')"
                [title]="appService.language_dictionary.text_editor_format_align_left"
                [disabled]="htmlMode"
                [hidden]="isButtonHidden('justifyLeft')"
                tabindex="-1">
            <mat-icon>format_align_left</mat-icon>
        </button>
        <button
            [id]="'justifyCenter-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('justifyCenter')"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_format_align_center"
                [hidden]="isButtonHidden('justifyCenter')"
                tabindex="-1">
            <mat-icon>format_align_center</mat-icon>
        </button>
        <button
            [id]="'justifyRight-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('justifyRight')"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_format_align_right"
                [hidden]="isButtonHidden('justifyRight')"
                tabindex="-1">
            <mat-icon>format_align_right</mat-icon>
        </button>
        <button
            [id]="'justifyFull-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('justifyFull')"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_format_align_justify"
                [hidden]="isButtonHidden('justifyFull')"
                tabindex="-1">
            <mat-icon>format_align_justify</mat-icon>
        </button>
    </div>
    <div
         [class.!hidden]="isButtonHidden('indent') || isButtonHidden('outdent')"
         class="angular-editor-toolbar-set">
        <button *ngIf="!isButtonHidden('indent')"
            [id]="'indent-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('indent')"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_indent"
                [hidden]="isButtonHidden('indent')" tabindex="-1">
            <mat-icon>format_indent_increase</mat-icon>
        </button>
        <button
            [id]="'outdent-'+id" type="button"class="angular-editor-button"
                (click)="triggerCommand('outdent')"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_outdent"
                [hidden]="isButtonHidden('outdent')" tabindex="-1">
            <mat-icon>format_indent_decrease</mat-icon>
        </button>
    </div>
    <div [class.!hidden]="isButtonHidden('insertUnorderedList') || isButtonHidden('insertOrderedList')"
         class="angular-editor-toolbar-set">
        <button *ngIf="!isButtonHidden('insertUnorderedList')"
            [id]="'insertUnorderedList-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('insertUnorderedList')"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_format_list_bulleted"
                [hidden]="isButtonHidden('insertUnorderedList')" tabindex="-1">
            <mat-icon>format_list_bulleted</mat-icon>
        </button>
        <button
            [id]="'insertOrderedList-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('insertOrderedList')"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_format_list_numbered"
                [hidden]="isButtonHidden('insertOrderedList')" tabindex="-1">
            <mat-icon>format_list_numbered</mat-icon>
        </button>
    </div>
    <div
         [class.!hidden]="isButtonHidden('heading')"
         class="angular-editor-toolbar-set">

        <ae-select class="select-heading" [options]="headings"
                   [(ngModel)]="block"
                   (change)="triggerCommand(block)"
                   [disabled]="htmlMode"
                   [hidden]="isButtonHidden('heading')"
                   tabindex="-1">
        </ae-select>
        <ng-container>

        </ng-container>
    </div>
    <div
         [class.!hidden]="isButtonHidden('fontName')"
        class="angular-editor-toolbar-set">

        <ae-select class="select-font" [options]="fonts"
                   [(ngModel)]="fontName"
                   (change)="setFontName(fontName)"
                   [disabled]="htmlMode"
                   [hidden]="isButtonHidden('fontName')"
                   tabindex="-1">
        </ae-select>
    </div>
    <div
         [class.!hidden]="isButtonHidden('fontSize')"
        class="angular-editor-toolbar-set">

        <ae-select class="select-font-size" [options]="fontSizes"
                   [(ngModel)]="fontSize"
                   (change)="setFontSize(fontSize)"
                   [disabled]="htmlMode"
                   [hidden]="isButtonHidden('fontSize')"
                   tabindex="-1">
        </ae-select>
    </div>
    <div
         [class.!hidden]="isButtonHidden('textColor') || isButtonHidden('backgroundColor')"
         class="angular-editor-toolbar-set">
        <input
            style="position: absolute; opacity: 0; margin-top: 10px;"
            type="color" (change)="insertColor(fgInput.value, 'textColor')"
            #fgInput>
        <button
            [id]="'foregroundColorPicker-'+id" type="button" class="angular-editor-button"
                (click)="focus(); ; fgInput.click()"
                title="Text Color"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_format_color_text"
                [hidden]="isButtonHidden('textColor')" tabindex="-1">
            <mat-icon>format_color_text</mat-icon>
        </button>
        <input
            style="position: absolute; opacity: 0; margin-top: 10px;"
            type="color" (change)="insertColor(bgInput.value, 'backgroundColor')"
            #bgInput>
        <button #buttonFontDownload
            [id]="'backgroundColorPicker-'+id" type="button" class="angular-editor-button"
                (click)="focus(); bgInput.click()"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_font_download"
                [hidden]="isButtonHidden('backgroundColor')" tabindex="-1">
            <mat-icon>font_download</mat-icon>
        </button>
    </div>
    <div *ngIf="_customClasses" class="angular-editor-toolbar-set">
        <ae-select class="select-custom-style" [options]="customClassList"
                   [(ngModel)]="customClassId"
                   (change)="setCustomClass(customClassId)"
                   [disabled]="htmlMode"
                   [hidden]="isButtonHidden('customClasses')"
                   tabindex="-1"></ae-select>
    </div>
    <div
         [class.!hidden]="isButtonHidden('link') || isButtonHidden('unlink')
                || isButtonHidden('insertResizedImage') || isButtonHidden('insertVideo')
                || isButtonHidden('insertHorizontalRule')"
        class="angular-editor-toolbar-set">
        <button
            [id]="'link-'+id" type="button" class="angular-editor-button" (click)="insertUrl()"
                [title]="appService.language_dictionary.text_editor_link_variant"
                [disabled]="isLinkButtonDisabled"
                [hidden]="isButtonHidden('link')" tabindex="-1">
            <mat-icon>link</mat-icon>
        </button>
        <button
            [id]="'unlink-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('unlink')"
                [disabled]="htmlMode || !linkSelected"
                [title]="appService.language_dictionary.text_editor_link_variant_off"
                [hidden]="isButtonHidden('unlink')" tabindex="-1">
            <mat-icon>link_off</mat-icon>
        </button>
        <input
            style="display: none"
            accept="image/*"
            type="file" (change)="onFileChanged($event)"
            #fileInput>
        <button
            [id]="'insertImage-'+id" type="button" class="angular-editor-button"
                (click)="focus(); fileInput.click()"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_image_area"
                [hidden]="isButtonHidden('insertResizedImage')" tabindex="-1">
            <mat-icon>image_area</mat-icon>
        </button>
        <button
            [id]="'insertVideo-'+id" type="button" class="angular-editor-button"
                (click)="insertVideo()"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_videocam"
                [hidden]="isButtonHidden('insertVideo')"
                tabindex="-1">
            <mat-icon>videocam</mat-icon>
        </button>
        <button
            [id]="'insertHorizontalRule-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('insertHorizontalRule')"
                [disabled]="htmlMode"
                [title]="appService.language_dictionary.text_editor_border_horizontal"
                [hidden]="isButtonHidden('insertHorizontalRule')" tabindex="-1">
            <mat-icon>border_horizontal</mat-icon>
        </button>
    </div>
    <div class="angular-editor-toolbar-set">
        <button
            [id]="'clearFormatting-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('removeFormat')"
                [title]="appService.language_dictionary.text_editor_close"
                [disabled]="htmlMode"
                [hidden]="isButtonHidden('removeFormat')"
                tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="angular-editor-toolbar-set">
        <button
            [id]="'toggleEditorMode-'+id" type="button" class="angular-editor-button"
                (click)="triggerCommand('toggleEditorMode')"
                [title]="appService.language_dictionary.text_editor_code"
                [hidden]="isButtonHidden('toggleEditorMode')"
                tabindex="-1">
            <mat-icon>code</mat-icon>
        </button>
    </div>
</div>
